function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useEffect } from 'react';
import { Field } from 'redux-form';
export var FormFieldTypes = Object.freeze({
  Checkbox: 'checkbox',
  Date: 'date',
  Number: 'number',
  Phone: 'phone',
  Radio: 'radio',
  RadioGroup: 'radioGroup',
  Select: 'select',
  Switch: 'switch',
  Text: 'text'
});
export var formField = function formField(formFieldType) {
  return function (WrappedComponent) {
    var FieldShim = function FieldShim(props) {
      useEffect(function () {
        checkForError(props);
      });

      var input = props.input,
          meta = props.meta,
          helperText = props.helperText,
          onError = props.onError,
          showError = props.showError,
          others = _objectWithoutProperties(props, ["input", "meta", "helperText", "onError", "showError"]);

      var valueProp = input.value,
          otherInput = _objectWithoutProperties(input, ["value"]);

      var params = setField(formFieldType, props);
      var value = setValue(formFieldType, props);
      return (
        /*#__PURE__*/
        React.createElement(WrappedComponent, _extends({}, otherInput, params, {
          error: meta.touched && meta.error ? true : undefined,
          value: value
        }, others))
      );
    };

    return function (props) {
      return (
        /*#__PURE__*/
        React.createElement(Field, _extends({}, props, {
          component: FieldShim
        }))
      );
    };
  };
};

function getDefaultValueForType(formFieldType) {
  switch (formFieldType) {
    case FormFieldTypes.Checkbox:
    case FormFieldTypes.Radio:
    case FormFieldTypes.Switch:
      return false;

    case FormFieldTypes.Number:
      return null;

    default:
      return '';
  }
}

var getValue = function getValue(formFieldType, props) {
  var value = props.input.value;
  var _props$meta = props.meta,
      initialValue = _props$meta.initial,
      dirty = _props$meta.dirty;

  if (dirty) {
    return value;
  }

  if (initialValue !== undefined) {
    return initialValue;
  } // ensures field is controlled


  return getDefaultValueForType(formFieldType);
};

var getBooleanValue = function getBooleanValue(formFieldType, props) {
  var value = getValue(formFieldType, props);
  return typeof value === 'boolean' ? value : false;
};

var setValue = function setValue(formFieldType, props) {
  var value = getValue(formFieldType, props);

  switch (formFieldType) {
    case FormFieldTypes.Checkbox:
    case FormFieldTypes.Radio:
    case FormFieldTypes.Switch:
      value = String(getBooleanValue(formFieldType, props));
      break;

    default:
      break;
  }

  return value;
};

var setField = function setField(formFieldType, props) {
  var params = {};
  var input = props.input;

  switch (formFieldType) {
    case FormFieldTypes.Date:
    case FormFieldTypes.Number:
    case FormFieldTypes.Select:
    case FormFieldTypes.Text:
      params.helperText = getHelperText(props);
      params.onChange = setOnChange(input);
      params.onBlur = setOnBlur(input);
      break;

    case FormFieldTypes.Checkbox:
    case FormFieldTypes.Radio:
    case FormFieldTypes.Switch:
      params.checked = getBooleanValue(formFieldType, props);
      params.onChange = setOnCheck(input);
      break;

    case FormFieldTypes.RadioGroup:
      params.helperText = getHelperText(props);
      params.onChange = setOnChange(input);
      break;

    case FormFieldTypes.Phone:
      params.onChange = setOnChange(input);
      break;

    default:
      break;
  }

  return params;
};

var setOnChange = function setOnChange(input) {
  return function () {
    if (input.onChange) {
      input.onChange.apply(input, arguments);
    }
  };
};

var setOnCheck = function setOnCheck(input) {
  return function (event) {
    return input.onChange ? input.onChange(event.target.checked) : event;
  };
}; // Prevent onBlur to update the field value
// Do not propagate the focus event object to redux-form
// https://github.com/erikras/redux-form/issues/2768


var setOnBlur = function setOnBlur(input) {
  return function () {
    if (input.onBlur) {
      input.onBlur();
    }
  };
};

var getHelperText = function getHelperText(props) {
  var meta = props.meta,
      helperText = props.helperText,
      _props$showError = props.showError,
      showError = _props$showError === void 0 ? true : _props$showError;
  var error = getError(meta);

  if (showError) {
    return error || helperText;
  }

  return helperText;
};

var checkForError = function checkForError(_ref) {
  var meta = _ref.meta,
      onError = _ref.onError;
  var error = getError(meta);

  if (onError) {
    onError(error);
  }
};

var getError = function getError(meta) {
  return meta.touched && meta.error ? meta.error : undefined;
};

export var testPort = {
  checkForError: checkForError,
  getBooleanValue: getBooleanValue,
  getError: getError,
  getHelperText: getHelperText,
  getValue: getValue,
  setValue: setValue,
  setField: setField,
  setOnChange: setOnChange,
  setOnCheck: setOnCheck,
  setOnBlur: setOnBlur
};